import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { DevRoeTalkGroup } from '#shared/lex'

type TalkGroupValue = Omit<DevRoeTalkGroup.Record, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New talk group - admin - Daniel Roe' })

async function save (value: TalkGroupValue) {
  await $fetch('/api/admin/talk-groups', { method: 'POST', body: value })
  await navigateTo('/admin/talks')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminTalkGroupForm = _resolveComponent("AdminTalkGroupForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New talk group" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminTalkGroupForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})